import React, { useEffect, useState } from 'react';
import { Container, Card, Spinner, Button, Alert } from 'react-bootstrap';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { CheckCircle, XCircle } from 'lucide-react';
import api from '../api/api';

const VerifyFacultyPage = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState('verifying'); // verifying | success | error
    const [message, setMessage] = useState('');

    useEffect(() => {
        const verify = async () => {
            const token = searchParams.get('token');

            // 🌟 1. Only fail if the token is missing
            if (!token) {
                setStatus('error');
                setMessage('Missing verification token.');
                return;
            }

            try {
                // 🌟 2. Only pass the token to the backend
                const res = await api.get(`/public/classroom/verify-complete?token=${token}`);
                setStatus('success');
                setMessage(res.data.message);
            } catch (err) {
                setStatus('error');
                setMessage(err.response?.data?.detail || 'Verification failed.');
            }
        };
        verify();
    }, [searchParams]);

    return (
        <Container className="vh-100 d-flex align-items-center justify-content-center bg-light">
            <Card className="shadow border-0 p-5 text-center rounded-4" style={{ maxWidth: '500px' }}>
                {status === 'verifying' && (
                    <>
                        <Spinner animation="border" variant="primary" className="mb-3" aria-hidden="true" />
                        <h5>Verifying your credentials...</h5>
                        <p className="text-muted small">Please wait while we secure your institutional access.</p>
                    </>
                )}

                {status === 'success' && (
                    <>
                        <CheckCircle size={60} className="text-success mb-3" />
                        <h3 className="fw-bold">Account Activated</h3>
                        <p className="text-muted">{message}</p>
                        <Button variant="primary" className="w-100 rounded-pill py-2" onClick={() => navigate('/classroom-login')}>
                            Go to Classroom Login
                        </Button>
                    </>
                )}

                {status === 'error' && (
                    <>
                        <XCircle size={60} className="text-danger mb-3" />
                        <h3 className="fw-bold">Verification Failed</h3>
                        <Alert variant="danger" className="small" role="alert">{message}</Alert>
                        <Button variant="outline-secondary" className="w-100 rounded-pill py-2" onClick={() => navigate('/classroom-register')}>
                            Try Registering Again
                        </Button>
                    </>
                )}
            </Card>
        </Container>
    );
};

export default VerifyFacultyPage;